import { App } from './app.class';
import { Fetch } from '../fetch.class';
import { Notification } from './notification.class';

export class Page {

    constructor() {

        // Elemente
        const $panelContainer = document.getElementById('panel-container');
        const $panelEmail = document.getElementById('panel-email');
        const $panelPassword = document.getElementById('panel-password');

        const $formEmail = $panelEmail.querySelector('form');
        const $formPassword = $panelPassword.querySelector('form');

        const $inputEmail = $formEmail.querySelector('input[name=email]');
        const $inputHiddenEmail = $formPassword.querySelector('input[name=email]');

        const $btnUserChange = $panelPassword.querySelector('a.change-user');
        const $btnPassreset = $panelPassword.querySelector('a.go-passreset');

        // Event: Absenden der Email-Adresse
        $formEmail.addEventListener('submit', event => {
            event.preventDefault();
            const $form = event.currentTarget;

            // Sendebutton deaktivieren
            App.setSubmitBtnLoading($form);

            // Übermittlung
            const formData = new FormData($form);
            new Fetch().post(App.getUrl('login'), formData)
            .then(response => {

                // Email übernehmen
                const $emailStr = $formPassword.querySelector('div.email');
                $emailStr.textContent = $inputEmail.value;
                $inputHiddenEmail.value = $inputEmail.value;

                // Fehlermeldung ausblenden
                const $otherErrorbox = $formPassword.querySelector('.errorbox');
                $otherErrorbox.classList.add('hidden');

                // zur Passworteingabe
                $panelEmail.classList.add('hidden');
                App.animateCSS($panelPassword, 'swoopInRight');
                $panelPassword.classList.remove('hidden');
            })
            .catch(error => {

                // kein Passwort hinterlegt > zur Erfassung
                if(error.message.substring(0, 11) == "no-password") {
                    App.goto('account', 'setuppassword', error.message.substring(12));
                }

                // Fehlermeldung anzeigen
                else {
                    const $errorbox = $panelEmail.querySelector('.errorbox');
                    const $cont = $errorbox.querySelector('.cont');
                    $cont.innerHTML = error.message;
                    App.animateCSS($errorbox, 'pullUp');
                    $errorbox.classList.remove('hidden');

                    // Box schütteln
                    App.animateCSS($panelContainer, 'shake');
                }
            })
            .finally(() => {

                // Sendebutton zurücksetzen
                App.setSubmitBtnActive($form);
            });
        });

        // Klick auf Neusendung von Freischaltungs-Mail
        document.addEventListener('click', event => {
            if(event.target.matches('a.resend_accountactivation')) {
                event.preventDefault();

                // Aktivierungmail neu senden
                new Fetch().get(App.getUrl('account', 'resendconfirmmail', $inputEmail.value))
                .then(response => {

                    // Erfolgsmeldung
                    new Notification().success(response.message_header, response.message_text);

                    // Fehlermeldung ausblenden
                    const $errorbox = $panelEmail.querySelector('.errorbox');
                    $errorbox.classList.add('hidden');
                })
                .catch(error => {

                    // Fehlermeldung
                    new Notification().error(error.message);
                });
            }
        });

        // Event: Benutzer wechseln
        $btnUserChange.addEventListener('click', event => {
            event.preventDefault();

            // Fehlermeldung ausblenden
            $panelEmail.querySelector('.errorbox').classList.add('hidden');

            // Email-Eingabe einblenden
            $panelPassword.classList.add('hidden');
            App.animateCSS($panelEmail, 'swoopInLeft');
            $panelEmail.classList.remove('hidden');
        });

        // Event: Passwort vergessen
        $btnPassreset.addEventListener('click', event => {
            event.preventDefault();
            let url = event.currentTarget.getAttribute('href');
            url += '?email='+$inputHiddenEmail.value;
            App.gotoUrl(url);
        });

        // Event: Anmeldung
        $formPassword.addEventListener('submit', event => {
            event.preventDefault();

            const $form = event.currentTarget;
            const $errorbox = $form.querySelector('.errorbox');

            let go_path = '';
            const $inputGoPath = $panelPassword.querySelector('input[name=go_path]');
            if($inputGoPath) {
                go_path = $inputGoPath.value;
            }

            // Sendebutton deaktivieren
            App.setSubmitBtnLoading($form);

            // Übermittlung
            const formData = new FormData($form);
            new Fetch().post(App.getUrl('login'), formData)
            .then(response => {

                // Weiterleitung zu Dashboard
                if(go_path == '')
                    App.goto();

                // bestimmter URL
                else
                    App.gotoUrl( window.location.protocol + "//" + window.location.hostname + "/" + go_path );
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                $errorbox.querySelector('.cont').innerHTML = error.message;
                App.animateCSS($errorbox, 'pullUp');
                $errorbox.classList.remove('hidden');

                // Box schütteln
                App.animateCSS($panelContainer, 'shake');
            })
            .finally(() => {

                // Sendebutton zurücksetzen
                App.setSubmitBtnActive($form);
            });
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('login')) {
        new Page();
    }
});
